import api from "../../../../../common/dependencies/utils/Api";
import {
  MENTOR_LIST,
  VIEW_PREDEFINED_OPTIONS,
  VIEW_MENTORLIST_COUNTER_OPTIONS,
} from "../../../../../common/constants/ApplicationUrl";

export const AdminMentorListServices = {
  getMentorList(params) {
    // if(localStorage.getItem("SavedLoggedInData") && JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role){
      return api
      .POST(`${MENTOR_LIST}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          //
          return response.data;
        } else {
          //
          //   toast.error("Invalid Username or Password");
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
    // }
  },
  getPredefineOptionsList() {
    return api
      .GET(`${VIEW_PREDEFINED_OPTIONS}`)
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (responseCode === 200) {
          return data;
        } else {
          return Promise.reject(response.data);
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
  getMentorlistCountersList(params) {
    return api
      .POST(`${VIEW_MENTORLIST_COUNTER_OPTIONS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
};
